import { render, staticRenderFns } from "./DealPdfDocumentViewer.vue?vue&type=template&id=423c0d4e&scoped=true"
import script from "./DealPdfDocumentViewer.vue?vue&type=script&lang=js"
export * from "./DealPdfDocumentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c0d4e",
  null
  
)

export default component.exports